import React, { useContext, useState } from "react"
import Fade from "@material-ui/core/Fade"
import Box from "@material-ui/core/Box"
/** Components */
import Table from "components/Table"
import Loader from "components/Loader"
/** Context */
import { Context } from "context/Dashboard/Attendance/main/Context"

import tableHeaders from "./tableHeaders"

interface Props {
  activeTable?: number
  activeStatus?: number
  date: any
  data: Record<string, any>
  showTimeout: Function
}

const TableAttendances: React.FC<Props> = ({ data }) => {
  const { setDownloadData, isValidating } = useContext(Context)
  const [currentPage, setCurrentPage] = useState(0)

  return (
    <Box>
      {isValidating ? (
        <Loader dark />
      ) : (
        <Fade in={!isValidating} timeout={2000}>
          <Box>
            <Table
              data={data || []}
              columns={tableHeaders}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              minRows={3}
              action={(values: any) =>
                setDownloadData &&
                setDownloadData(
                  values?.map((i: any) => {
                    return {
                      "Date": i?.date,
                      "Name": i?.name,
                      "Category": i?.category,
                      "Position": i?._original?.user_role_name,
                      "Time in": i?.timein,
                      "Time out": i?.timeout
                    }
                  })
                )}
            />
          </Box>
        </Fade>
      )}
    </Box>
  )
}

export default TableAttendances
